import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { DialogueHandler, AccountTransferDialogueHandler } from './types';
import AccountTransferDialogueContext from './AccountTransferContext';

const { ConfirmationDialogue } = vp;

type AccountTransferDialogueProps = {
  handleDialogue: DialogueHandler<AccountTransferDialogueHandler>;
};

type FC = FunctionComponent<AccountTransferDialogueProps>;

const AccountTransferDialogue: FC = ({ handleDialogue }: AccountTransferDialogueProps) => {
  const { showAccountTransferErrorAlert, accountTransferError } = useContext(AccountTransferDialogueContext);

  return useMemo(
    () => (
      <div>
        {/* Transfer Fund Error */}
        <ConfirmationDialogue
          isVisible={showAccountTransferErrorAlert}
          title="Error! The transfer was not completed."
          status="error"
          subTitle={`${accountTransferError}`}
          confirm={{
            label: 'Back',
            action: () => handleDialogue({ type: 'error', state: 'confirm' }),
          }}
        />
      </div>
    ),
    [showAccountTransferErrorAlert, accountTransferError],
  );
};

export default AccountTransferDialogue;
